import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { fetchNotesFailure, fetchNotesSuccess } from "../slices/features/notes";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* fetchNotesSaga(action: any) {
  const { payload } = action;
  const { id, meta } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.fetchNotes,
      baseUrl,
      id,
      meta
    );

    yield put(fetchNotesSuccess({ ...response, items: [] }));

    payload?.cbSuccess && payload?.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(fetchNotesFailure({ statusCode, statusText }));
  }
}

export function* watchfetchNotes() {
  yield takeLatest(RequestTypes.GET_NOTES_REQUEST, fetchNotesSaga);
}
